/**
 * Whether PixelPet avatars draw as pets, or as a simple dot — owner,
 * 2026-08-26: 主選單…一個開關, Enable / Disable Avengents Pixel Avatar.
 * Disable 的時候, 所有 PixelPet 的頭像都會被改為一個簡單的小圓圈.
 *
 * A per-viewer VISUAL preference, so it lives where the theme does: this
 * browser's localStorage, not the account (a pin is a fact about your account;
 * how avatars are drawn is a fact about this screen). Default ON — the pets
 * are the product's face; the switch exists for the reader who finds them
 * noisy.
 *
 * A module store with subscribers rather than React state, because PixelPet
 * renders in thirty-plus places across every panel and the toggle must flip
 * ALL of them live — useSyncExternalStore in the component, one setter here.
 */

const KEY = 'wt_pixel_avatars'
const listeners = new Set<() => void>()

export function pixelAvatarsOn(): boolean {
  try {
    return localStorage.getItem(KEY) !== '0'
  } catch {
    return true
  }
}

export function setPixelAvatars(on: boolean): void {
  try {
    if (on) localStorage.removeItem(KEY)
    else localStorage.setItem(KEY, '0')
  } catch {
    /* private mode: the flip still applies for this page's lifetime */
  }
  for (const cb of [...listeners]) cb()
}

export function subscribePixelAvatars(cb: () => void): () => void {
  listeners.add(cb)
  return () => listeners.delete(cb)
}
